var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    { attrs: { "label-width": "130px" } },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "剩余积分" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.theRestIntegral,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "theRestIntegral", $$v)
                      },
                      expression: "detailsData.theRestIntegral",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "扫码开瓶数" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.openNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "openNumber", $$v)
                      },
                      expression: "detailsData.openNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "最多开瓶系列" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.openProductName,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "openProductName", $$v)
                      },
                      expression: "detailsData.openProductName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "签到天数" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.signInDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "signInDays", $$v)
                      },
                      expression: "detailsData.signInDays",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "连续签到最长天数" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.continuousSignInDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.detailsData, "continuousSignInDays", $$v)
                      },
                      expression: "detailsData.continuousSignInDays",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "拉新人数" } },
                [
                  _c("el-input", {
                    attrs: { readonly: "" },
                    model: {
                      value: _vm.detailsData.acquireNewCustomersNumber,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.detailsData,
                          "acquireNewCustomersNumber",
                          $$v
                        )
                      },
                      expression: "detailsData.acquireNewCustomersNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("div", { staticClass: "form-title" }, [
                _vm._v("积分获取记录"),
              ]),
              _c("RecordPointsAcquisition", {
                attrs: { value: _vm.detailsData },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("div", { staticClass: "form-title" }, [_vm._v("兑换记录")]),
              _c("ExchangeRecord", { attrs: { value: _vm.detailsData } }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }